import {
  createEntityAdapter,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { DrilldownJsonApiResponse } from 'api/normalized/insightDrilldown/InsightDrilldownApi';
import { transformTaskDrilldownData } from 'api/normalized/insightDrilldown/transformers';
import { RootState } from 'state/store';
import { TaskDrillDownItem } from 'types/store/normalized/insightsDrillDown';
import { JsonApiResource } from 'types/store/jsonApi';
import { TaskDrillDownApiResponse } from 'api/normalized/insightDrilldown/types';

/* ============================== STATE SETUP =============================== */
const insightDrilldownTasksAdapter = createEntityAdapter<TaskDrillDownItem>();

/* ================================= REDUCER ================================ */
const insightDrilldownTasksSlice = createSlice({
  name: 'normalized/insightDrilldownTasks',
  initialState: insightDrilldownTasksAdapter.getInitialState(),
  reducers: {
    addTasks: (
      state,
      action: PayloadAction<DrilldownJsonApiResponse['data']>
    ) => {
      const taskDrilldowns = transformTaskDrilldownData(
        action.payload as JsonApiResource<TaskDrillDownApiResponse>[]
      );
      insightDrilldownTasksAdapter.setMany(state, taskDrilldowns);
    },
  },
});

/* =============================== SELECTORS ================================ */
const defaultSelectors = insightDrilldownTasksAdapter.getSelectors<RootState>(
  (state) => state.normalized.insightDrilldownTasks
);

const selectTasksByIds = (
  state: RootState,
  ids: string[]
): TaskDrillDownItem[] =>
  ids
    .map((id) => defaultSelectors.selectById(state, id))
    .filter((item) => !!item);

/* ================================ EXPORTS ================================= */
export const insightDrilldownTasksSelectors = {
  ...defaultSelectors,
  selectTasksByIds,
};
export const { addTasks } = insightDrilldownTasksSlice.actions;
export default insightDrilldownTasksSlice.reducer;
